<div class="row bloccodati">
  <div labelTextInput class="col-sm-6" [typeLabel]="'text'"
       [labelInput]="'Tipo richiedente'" [valueInput]="ctxBodyFascicolo.fascicolo.tipoRichiedente ? 'Interno' : 'Esterno'"></div>
  <div labelTextInput class="col-sm-6" [typeLabel]="'text'"
       [labelInput]="'Oggetto'" [valueInput]="ctxBodyFascicolo.fascicolo.oggetto"></div>
</div>
<div class="row bloccodati">
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Atto della società'" [valueInput]="ctxBodyFascicolo.fascicolo.opposizione ? 'Si' : 'No'"></div>
  <div labelTextInput class="col-sm-4" [typeLabel]="'text'"
       [labelInput]="'Tipo provvedimento'" [valueInput]="null"></div>
</div>
<div class="row bloccodati">
  <div labelTextInput class="col-sm-6" [typeLabel]="'text'"
       [labelInput]="'Organo ispettivo'" [valueInput]="ctxBodyFascicolo.fascicolo.organoIspettivo.label"></div>
  <div labelTextInput class="col-sm-6" [typeLabel]="'text'"
       [labelInput]="'Provincia'" [valueInput]="ctxBodyFascicolo.fascicolo.provincia.label"></div>
</div>

<div class="row">
  <div class="col-sm-12 bloccodati">
    <p>
      <label class="col-sm-12">Note</label>
      <span class="longtext">{{ ctxBodyFascicolo.fascicolo.note }}</span>
    </p>
  </div>
</div>
